__turbopack_context__.v({
  "dialog": "nR4iHG_dialog",
  "icon": "nR4iHG_icon",
  "iconAlert": "nR4iHG_iconAlert",
  "subtitle": "nR4iHG_subtitle",
  "title": "nR4iHG_title",
});
